<!--
 * @Author: wzh
 * @LastEditTime: 2024-10-14 10:32:42
 * @Description: 忘记密码
-->
<template>
  <div class="forget_main">
    <a-steps :current="current">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" />
    </a-steps>
    <div class="steps-content">
      <component
        :safeSetInfo="safeSetInfo"
        :safeParams="safeParams"
        :is="steps[current]['comp']"
        @next="
          (val, params = null) => {
            current = val;
            if (val == 2) safeParams = params;
          }
        "
        @success="() => $emit('success')"
      ></component>
    </div>
  </div>
</template>
<script>
import Account from "./components/Account"; // 账号验证
import Safe from "./components/Safe"; // 安全验证
import Personal from "./components/Personal"; // 实名认证
import Setpass from "./components/Setpass"; // 设置密码
import Success from "./components/Success"; // 密码找回成功
import { commonAPI } from "@/apis";

export default {
  components: { Account, Safe, Personal, Setpass, Success },
  data() {
    return {
      current: 0,
      steps: [
        { title: this.$t("login.forget.step_one"), comp: "Account" },
        { title: this.$t("login.forget.step_two"), comp: "Safe" },
        { title: this.$t("login.forget.step_three"), comp: "Setpass" },
        { title: this.$t("login.forget.step_four"), comp: "Success" },
        // { title: "实人认证", comp: "Personal" },
      ],
      safeSetInfo: {},
      // 安全验证参数
      safeParams: {},
    };
  },
  created() {
    this.getSafeSet();
  },
  methods: {
    // 获取安全配置
    async getSafeSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/safe/get"
      );
      if (code == 0) {
        this.safeSetInfo = { ...data };
      } else {
        this.$message.error(message);
      }
    },
  },
};
</script>
<style scoped lang="less">
.forget_main {
  padding: 30px 30px 40px;

  .steps-content {
    margin-top: 45px;
  }
}
</style>
